/* 🤖 this file was generated by svg-to-ts */
export const emperorIconDataUpload1: {
  name: 'data_upload_1';
  data: string;
} = {
  name: 'data_upload_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M12 2.00098C6.486 2.00098 2 6.48598 2 12.001C2 17.515 6.486 22.001 12 22.001C17.514 22.001 22 17.515 22 12.001C22 6.48698 17.514 2.00098 12 2.00098ZM12 20.001C7.589 20.001 4 16.411 4 12.001C4 7.58898 7.589 4.00098 12 4.00098C16.411 4.00098 20 7.58898 20 12.001C20 16.412 16.411 20.001 12 20.001Z"/><path d="M7.29297 10.2939L8.70697 11.7079L11 9.41591V18.0009H13V9.41591L15.293 11.7079L16.707 10.2939L12 5.58691L7.29297 10.2939Z"/></g><defs><clipPath id="clip0"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>`
};
